export function isExternal(href: string): boolean {
  return ["https", "http"].some((protocol) =>
    href.startsWith(`${protocol}://`),
  );
}

export const askForProducts = new URL("https://form.typeform.com/to/JGpmJn4n");
